// /utils/timeOfDay.js
export function pickTimeOfDay(date = new Date()) {
  const h = date.getHours();
  if (h >= 5 && h < 10)  return "morning";
  if (h >= 10 && h < 17) return "day";
  if (h >= 17 && h < 21) return "evening";
  return "night";
}

export function greetingFor(timeOfDay) {
  switch (timeOfDay) {
    case "morning": return { text: "Guten Morgen", emoji: "🌅" };
    case "day":     return { text: "Guten Tag",    emoji: "☀️" };
    case "evening": return { text: "Guten Abend",  emoji: "🌇" };
    default:        return { text: "Gute Nacht",   emoji: "🌙" };
  }
}

/* Optional: smarter Timer – wechselt genau am nächsten Grenzzeitpunkt */
export function msUntilNextBoundary(now = new Date()) {
  const h = now.getHours();
  const boundaries = [5,10,17,21].map(x => {
    const d = new Date(now); d.setHours(x,0,0,0); return d;
  }).sort((a,b)=>a-b);

  const next = boundaries.find(d => d > now) || (() => {
    const d = new Date(now); d.setDate(d.getDate()+1); d.setHours(5,0,0,0); return d;
  })();
  return next - now + 50; // +50ms Puffer
}
